// @ts-nocheck
import React, { useEffect, useState, useMemo } from 'react';
import { Row, Col, Card,Collapse, Space, DatePicker, Drawer, Form, Input, Select, Radio, message, Modal, Pagination, InputNumber, Image, Divider } from 'antd';
import { Table, Button, Tooltip} from 'antd';
import * as config from '../../service/config';
import BreadcrumbCustom from '../../components/widget/BreadcrumbCustom';
import { DownOutlined, ExclamationCircleOutlined, PlusOutlined, SearchOutlined, MinusOutlined, MinusCircleOutlined,EditOutlined,CopyOutlined,FileSearchOutlined,FileTextOutlined,ClockCircleOutlined,RedoOutlined } from '@ant-design/icons';
import { IStudent, listFixStudents,listCourseInvalidStudents, createStudent, createStudentFull, updateStudent,stopStudent,resumeStudent, deleteStudent, pageStudents } from '../../service/api/student';
import { IStore, listStores } from '../../service/api/store';
import { ITeachClass, listTeachClasss } from '../../service/api/teachClass';
import moment from 'moment';
import { ICardDefinition, listCardDefinitions } from '../../service/api/cardDefinition';
import { ICard, createCard, calculateEffectiveEndTime } from '../../service/api/card';
import { ICourseDefinition, listCourseDefinitions } from '../../service/api/courseDefinition';
import { FormInstance } from 'antd/lib/form/Form';
import Axios from 'axios';
import { IFile, listFilesByStudentId } from '../../service/api/file';
import { listPayWay, IPayWay } from '../../service/api/financeRecord';
import { number } from 'echarts';
const { confirm } = Modal;
const { Option } = Select;
const { Panel } = Collapse;

const StudentView = (props: any) => {
  const [students, setStudents] = useState<IStudent[]>();
  const [stores, setStores] = useState<IStore[]>();
  const [teachClasss, setTeachClasss] = useState<ITeachClass[]>();
  const [courseDefinitions, setCourseDefinitions] = useState<ICourseDefinition[]>();
  const [cardDefinitions, setCardDefinitions] = useState<ICardDefinition[]>();
  const [files, setFiles] = useState<IFile[]>();
  const [studentDetail, setStudentDetail] = useState<IStudent>();
  const [buyStudentDetail, setBuyStudentDetail] = useState<IStudent>();
  const [studentVisible, setStudentVisible] = useState(false);
  const [studentFullVisible, setStudentFullVisible] = useState(false);
  const [buyVisible, setBuyVisible] = useState(false);
  const [studentModalVisible, setStudentModalVisible] = useState(false);
  const [pageNum, setPageNum] = useState(1);
  const [pageTotal, setPageTotal] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [courseCountLess, setCourseCountLess] = useState<number>(undefined);
  const [filterSexs, setFilterSexs] = useState(undefined);
  const [filterStoreIds, setFilterStoreIds] = useState(undefined);
  const [filterTeachClassIds, setFilterTeachClassIds] = useState(undefined);
  const [searchKeyword, setSearchKeyword] = useState<string>();
  const [index, setIndex] = useState<number>();
  const [payWays, setPayWays] = useState<IPayWay[]>();
  const formRef = React.createRef<FormInstance>();
  const buyformRef = React.createRef<FormInstance>();
  const fullformRef = React.createRef<FormInstance>();
  const [fixStudents, setFixStudents] = useState<IStudent[]>();
  const [courseInvalidStudents, setCourseInvalidStudents] = useState<IStudent[]>();
  const [loading, setLoading] = useState(false);
  const [buyCardDefinitionId, setBuyCardDefinitionId] = useState<number>();
  const [buyCardCount, setBuyCardCount] = useState<number>();
  const [buyCardCalculateType, setBuyCardCalculateType] = useState<number>();

  const arr = (courseDefinitions || []).map((item: ICourseDefinition) => {
    return {
      title: item.name,
      dataIndex: String(item.id),
      key: String(item.id),
      width: 140,
      render: (text: any, record: any) => {
        var x = record.courseCountMap[item.id] || 0;
        if(x==0){
          return <span style={{ color: 'black' }}>{x}</span>
        }else if(x>0){
          return <span style={{ color: 'green' }}>{x}</span>
        }else{
          return <span style={{ color: 'red' }}>{x}</span>
        }
      }
    }
  }) || [];

  const columns = [
    {
      title: '学号',
      dataIndex: 'num',
      width: 80,
      key: 'num',
    },
    {
      title: '姓名',
      dataIndex: 'name',
      width: 80,
      key: 'name',
      render: (text: any, record: any, index: any) => {
        return <a onClick={() => {
          setStudentModalVisible(true);
          setIndex(index);
          setStudentDetail(record);
          listFilesByStudentId(record.id).then((info: any) => {
            setFiles(info?.data);
          });
        }}>{record.name}</a>
      }
    },
    {
      title: '性别',
      dataIndex: 'sex',
      width: 80,
      key: 'sex',
      filters: [
        {
          text: '男',
          value: '1',
        },
        {
          text: '女',
          value: '0',
        }
      ],
      render: (text: any, record: any) => {
        if (record.sex == 1) {
          return '男'
        } else {
          return '女'
        }
      }
    },
    // {
    //   title: '联系电话',
    //   dataIndex: 'phone',
    //   key: 'phone',
    // },
    // {
    //   title: '生日',
    //   dataIndex: 'birthday',
    //   key: 'birthday',
    //   render(val: Date) {
    //     return val ? moment(val).format('YYYY-MM-DD') : <>&mdash;</>
    //   },
    // },
    {
      title: '最后打卡记录',
      width: 180,
      dataIndex: 'lastPunchTime',
      key: 'lastPunchTime',
      render(val: Date) {
        return val ? moment(val).format('YYYY-MM-DD HH:mm') : <>&mdash;</>
      },
    },
    {
      title: '所属班级',
      width: 180,
      dataIndex: 'teachClassNames',
      key: 'teachClassNames',
      filterSearch: true,
      render(val: string) {
        return val || <>&mdash;</>
      },
      filters: (teachClasss || []).map((item: ITeachClass) => {
        return {
          text: item.name,
          value: String(item.id),
        }
      }) || [],
    },
    {
      title: '微信号',
      dataIndex: 'bindWeChat',
      width: 80,
      key: 'bindWeChat',
      render: (text: any, record: any) => {
        if (record.bindWeChat == 1) {
          return <div style={{ backgroundColor: '#00A600', color: 'white', width: '50px', textAlign: 'center', borderRadius: '5px' }}>已绑定</div>
        } else {
          return <div style={{ backgroundColor: '#CCCCCC', color: 'white', width: '50px', textAlign: 'center', borderRadius: '5px' }}>未绑定</div>
        }
      }
    },
    {
      title: '微信绑定码',
      dataIndex: 'bindWechatCode',
      width: 110,
      key: 'bindWechatCode'
    },
    {
      title: '所属门店',
      width: 180,
      dataIndex: 'storeName',
      key: 'storeName',
      // filters: (stores || []).map((item: IStore) => {
      //   return {
      //     text: item.name,
      //     value: String(item.id),
      //   }
      // }) || [],
    },
    {
      title: '备注',
      width: 180,
      dataIndex: 'remark',
      key: 'remark',
    },
    {
      title: '过期失效课程数',
      width: 140,
      dataIndex: 'invalidCourseCount',
      key: 'invalidCourseCount',
      render: (text: any, record: any) => {
        if(record.invalidCourseCount==0){
          return <span style={{ color: 'gray' }}>{record.invalidCourseCount}</span>
        }else{
        return <span style={{ color: 'red' }}>{record.invalidCourseCount}</span>
        }
      }
    },
    // {
    //   title: '状态',
    //   dataIndex: 'status',
    //   width: 80,
    //   key: 'status',
    //   render: (text: any, record: any) => {
    //     if (record.status == 'valid') {
    //       return <div style={{ backgroundColor: '#00A600', color: 'white', width: '50px', textAlign: 'center', borderRadius: '5px' }}>生效中</div>
    //     } else {
    //       return <div style={{ backgroundColor: '#CCCCCC', color: 'white', width: '50px', textAlign: 'center', borderRadius: '5px' }}>停卡中</div>
    //     }
    //   }
    // },
    {
      title: '操作',
      fixed: 'right' as 'right',
      width: 160,
      key: 'action',
      render: (text: any, record: any) => (
        <Space size="middle">
         <Tooltip title="编辑">
          <EditOutlined onClick={() => {
            setStudentDetail(record);
            setStudentVisible(true);
          }} />
          </Tooltip>
          <Tooltip title="补录课包">
          <CopyOutlined onClick={() => {
            setStudentDetail(record);
            setBuyStudentDetail({
              ...record,
              remark: '',
              count: 1,
              sendGifts: "false",
              signContract: "false",
            });
            setBuyVisible(true);
          }} />
          </Tooltip>
          <Tooltip title="查询课包">
          <a target="_blank" href={'#/app/student/card?studentId=' + record.id} ><FileSearchOutlined /> </a>
          </Tooltip>
          <Tooltip title="查询打卡记录">
          <a target="_blank" href={'#/app/student/punchRecord?studentId=' + record.id}><FileTextOutlined /> </a>
          </Tooltip>  
          <Tooltip title="学员详情">
          <a target="_blank" href={'#/wechat/studentInfo?studentId=' + record.id} ><FileSearchOutlined /> </a>
          </Tooltip>
          {/* {record.status=='stop'?
          <Tooltip title="复卡">
          <RedoOutlined onClick={e => { onResume(e, record) }} />
          </Tooltip>:
          <Tooltip title="停卡">
          <ClockCircleOutlined onClick={e => { onStop(e, record) }} />
          </Tooltip>} */}

          {/* <a onClick={e=>{onDelete(e,record)}}>删除 </a> */}
        </Space>
      ),
    }
  ];
  columns.splice(4, 0, ...arr);

  useEffect(() => {
    loadData();
  }, [pageNum, pageSize, filterSexs, filterTeachClassIds, filterStoreIds]);

  useEffect(() => {
    if (studentDetail) {
      let copyFormData = JSON.parse(JSON.stringify(studentDetail))
      if (typeof (copyFormData.birthday) === 'string') {
        copyFormData.birthday = moment(new Date(studentDetail.birthday));
      }
      // 设置100毫秒的延迟 确保from组件已经加载完毕
      setTimeout(() => {
        formRef?.current?.setFieldsValue(copyFormData);
      }, 100);

    }
    if (buyStudentDetail) {
      let copyFormData = JSON.parse(JSON.stringify(buyStudentDetail))
      if (typeof (copyFormData.birthday) === 'string') {
        copyFormData.birthday = moment(new Date(buyStudentDetail.birthday));
      }
      if (typeof (copyFormData.effectiveEndTime) === 'string') {
        copyFormData.effectiveEndTime = moment(new Date(studentDetail.effectiveEndTime));
      }
      // 设置100毫秒的延迟 确保from组件已经加载完毕
      setTimeout(() => {
        if (buyformRef.current) {
          buyformRef.current.setFieldsValue(copyFormData);
        }
      }, 100);
    }
  }, [studentDetail, buyStudentDetail]);

  const loadData = () => {
    pageStudents(pageNum, pageSize, filterSexs || '', filterStoreIds || '', filterTeachClassIds || '', searchKeyword || '',courseCountLess||'').then((info: any) => {
      setStudents(info?.data.list);
      setPageTotal(info?.data.total);
      // console.log("info:" + JSON.stringify(info.data));
    });
    listStores().then((info: any) => {
      setStores(info?.data);
    });
    listCardDefinitions().then((info: any) => {
      setCardDefinitions(info?.data);
    });
    listCourseDefinitions().then((info: any) => {
      setCourseDefinitions(info?.data);
    });
    listTeachClasss().then((info: any) => {
      setTeachClasss(info?.data);
    });
    listPayWay().then((info: any) => {
      setPayWays(info?.data);
    });
    listFixStudents(filterSexs || '', filterStoreIds || '', filterTeachClassIds || '', searchKeyword || '').then((info: any) => {
      setFixStudents(info?.data);
    });
    listCourseInvalidStudents(filterSexs || '', filterStoreIds || '', filterTeachClassIds || '', searchKeyword || '').then((info: any) => {
      setCourseInvalidStudents(info?.data);
    });
  }

  const onFinish = (values: any) => {
    setLoading(true);
    if (studentDetail) {
      updateStudent({
        ...values,
        id: studentDetail.id
      }).then((info: any) => {
        console.log("info:" + JSON.stringify(info));
        if (info) {
          message.success("更新成功");
          onClose();
          setLoading(false);
          loadData();
        }
      });
    } else {
      createStudent(values).then((info: any) => {
        console.log("info:" + JSON.stringify(info));
        if (info) {
          message.success("创建成功");
          onClose();
          setLoading(false);
          loadData();
        }
      });
    }
  };

  const onFinishFull = (values: any) => {
    setLoading(true);
    if (studentDetail) {
      updateStudent({
        ...values,
        id: studentDetail.id
      }).then((info: any) => {
        console.log("info:" + JSON.stringify(info));
        if (info) {
          message.success("更新成功");
          onClose();
          setLoading(false);
          loadData();
        }
      });
    } else {
      createStudentFull(values).then((info: any) => {
        console.log("info:" + JSON.stringify(info));
        if (info) {
          message.success("创建成功");
          onClose();
          setLoading(false);
          loadData();
        }
      });
    }
  };

  const onDelete = (e: any, item: IStudent) => {
    e.stopPropagation();
    confirm({
      title: '提示',
      icon: <ExclamationCircleOutlined />,
      content: '确定要删除该学员吗？删除后无法恢复',
      okText: '确定',
      okType: 'danger',
      cancelText: '取消',
      onOk() {
        deleteStudent(item.id).then((info: any) => {
          console.log("info:" + JSON.stringify(info));
          message.success("删除成功");
          loadData();
        });
      },
      onCancel() {
      },
    });
  }

  const onResume = (e: any, item: IStudent) => {
    e.stopPropagation();
    confirm({
      title: '提示',
      icon: <ExclamationCircleOutlined />,
      content: '确定要恢复该学员的课包为进行中吗？',
      okText: '确定',
      okType: 'danger',
      cancelText: '取消',
      onOk() {
        resumeStudent(item).then((info: any) => {
          console.log("info:" + JSON.stringify(info));
          message.success("复卡成功");
          loadData();
        });
      },
      onCancel() {
      },
    });
  }

  const onStop = (e: any, item: IStudent) => {
    e.stopPropagation();
    confirm({
      title: '提示',
      icon: <ExclamationCircleOutlined />,
      content: '确定要停止该学员的课包吗？',
      okText: '确定',
      okType: 'danger',
      cancelText: '取消',
      onOk() {
        stopStudent(item).then((info: any) => {
          console.log("info:" + JSON.stringify(info));
          message.success("停卡成功");
          loadData();
        });
      },
      onCancel() {
      },
    });
  }

  const onClose = () => {
    setStudentDetail(undefined);
    setBuyStudentDetail(undefined);
    setBuyCardCount(undefined)
    setBuyCardCalculateType(undefined)
    setBuyCardDefinitionId(undefined)
    setStudentVisible(false);
    setBuyVisible(false);
    setStudentFullVisible(false);
    if (formRef.current) {
      formRef.current!.resetFields();
    }
    if (buyformRef.current) {
      buyformRef.current!.resetFields();
    }
    if (fullformRef.current) {
      fullformRef.current!.resetFields();
    }
  }

  function onChange(pagination, filters, sorter, extra) {
    console.log('params', pagination, filters, sorter, extra);
    setFilterSexs(filters.sex);
    setFilterStoreIds(filters.storeName);
    setFilterTeachClassIds(filters.teachClassNames);
  }

  const onPageChange = (pageNum: number, pageSize?: number) => {
    console.log("pageNum:" + pageNum);
    console.log("pageSize:" + pageSize);
    setPageNum(pageNum);
    setPageSize(pageSize || 10);
    // setPageSize(info.data.pageSize);
  }

  // 下拉框值
  const storeOptions = stores?.map((store) =>
    <Option key={store.id} value={store.id}>{store.name}</Option>);

  const buyCard = (values: any) => {
    setLoading(true);
    if (buyStudentDetail) {
      createCard({
        ...values,
        studentId: buyStudentDetail.id
      }).then((info: any) => {
        if (info) {
          message.success("补录课包成功");
          onClose();
          setBuyVisible(false);
          setLoading(false);
          loadData();
        }
      });
    }
  };
  // 【知识点】使用async将异步接口调用转成同步返回
  const onChangeCardDefinition = async (value: any) => {
    const cardDefinition = cardDefinitions?.filter((record) => record.id == value)[0];
    const info = await calculateEffectiveEndTime({
      cardDefinitionId: value,
        studentId: studentDetail?.id,
        type: buyCardCalculateType,
        count: buyCardCount
    });
    console.log("info:" + JSON.stringify(info));
    if (info) {
      buyformRef?.current?.setFieldsValue({
        cardDefinitionEffectDay: cardDefinition?.effectiveDay,
        costPrice: cardDefinition?.sellPrice,
        effectiveEndTime: moment(info.data),
      });
      setBuyCardDefinitionId(value)
    }
  }

  const onChangeCardDefinition2 = async (value: any) => {
    const cardDefinition = cardDefinitions?.filter((record) => record.id == value)[0];
    const info = await calculateEffectiveEndTime({
      cardDefinitionId: value,
        studentId: studentDetail?.id,
        type: buyCardCalculateType,
        count: buyCardCount
    });
    console.log("info:" + JSON.stringify(info));
    if (info) {
      fullformRef?.current?.setFieldsValue({
        cardDefinitionEffectDay: cardDefinition?.effectiveDay,
        cardCostPrice: cardDefinition?.sellPrice,
        cardEffectiveEndTime: moment(info.data),
      });
      setBuyCardDefinitionId(value)
    }
  }

  const onChangeCalculateType = async(value: any) => {
    // 计算课包有效时间
    if(buyCardDefinitionId){
      const info = await calculateEffectiveEndTime({
        cardDefinitionId: buyCardDefinitionId,
          studentId: studentDetail.id,
          type: value,
          count: buyCardCount
        });
        console.log("info:" + JSON.stringify(info));
      if (info) {
        buyformRef?.current?.setFieldsValue({
          effectiveEndTime: moment(info.data),
        });
        setBuyCardCalculateType(value)
      }
    }
  }

  const onChangeCalculateType2 = async(value: any) => {
    // 计算课包有效时间
    if(buyCardDefinitionId){
      const info = await calculateEffectiveEndTime({
        cardDefinitionId: buyCardDefinitionId,
          studentId: studentDetail?.id,
          type: value,
          count: buyCardCount
        });
        console.log("info:" + JSON.stringify(info));
      if (info) {
        fullformRef?.current?.setFieldsValue({
          effectiveEndTime: moment(info.data),
        });
        setBuyCardCalculateType(value)
      }
    }
  }

  const onChangeBuyCardCount = async(value: any) => {
    if(buyCardDefinitionId){
      const info = await calculateEffectiveEndTime({
        cardDefinitionId: buyCardDefinitionId,
          studentId: studentDetail.id,
          type: buyCardCalculateType,
          count: value
        });
        console.log("info:" + JSON.stringify(info));
      if (info) {
        buyformRef?.current?.setFieldsValue({
          effectiveEndTime: moment(info.data),
        });
        setBuyCardCount(value)
      }
    }
  }

  const onChangeBuyCardCount2 = async(value: any) => {
    if(buyCardDefinitionId){
      const info = await calculateEffectiveEndTime({
        cardDefinitionId: buyCardDefinitionId,
          studentId: studentDetail?.id,
          type: buyCardCalculateType,
          count: value
        });
        console.log("info:" + JSON.stringify(info));
      if (info) {
        fullformRef?.current?.setFieldsValue({
          cardEffectiveEndTime: moment(info.data),
        });
        setBuyCardCount(value)
      }
    }
  }

  // 下拉框值
  const payWayOptions = payWays?.map((payWay) =>
    <Option key={payWay.value} value={payWay.value}>{payWay.name}</Option>);
  // 下拉框值
  const cardDefinitionOptions = cardDefinitions?.map((cardDefinition) =>
    <Option key={cardDefinition.id} value={cardDefinition.id}>{cardDefinition.name}</Option>);
  // 搜索
  const onSearchKeyword = (e: { target: { value: React.SetStateAction<string | undefined>; }; }) => {
    // console.log(e.target.value);
    setSearchKeyword(e.target.value);
  };
  return (
    <div className="gutter-example">
      <BreadcrumbCustom breads={['学员管理']} />
      <Row gutter={16}>
        <Col className="gutter-row" md={24}>
          <div className="gutter-box">
            <Card title="学员管理" bordered={false} extra={
              <div>
                <InputNumber type='text' placeholder="常规课小于" style={{ width: 120, marginLeft: '10px' }}
                  onChange={(value: any) => {
                    console.log("111"+value);
                    
                    setCourseCountLess(value);
                  }}
                   onKeyPress={loadData} allowClear>
                </InputNumber>
                <Select placeholder="全部校区"
                  style={{ minWidth: 180, marginLeft: '10px' }} mode="multiple"
                  onChange={(value: any) => {
                    setFilterStoreIds(value);
                  }}
                // allowClear
                >
                  {storeOptions}
                </Select>
                <Input type='text' placeholder="请输入姓名" style={{ width: 160, marginLeft: '10px' }}
                  onChange={onSearchKeyword} onKeyPress={loadData} allowClear>
                </Input>
                <Button type="ghost" style={{ width: 100, marginLeft: '10px' }} icon={<SearchOutlined />} onClick={() => {
                  loadData();
                }}>搜索</Button>
                <Button type="primary" onClick={() => {
                  setStudentVisible(true);
                }} icon={<PlusOutlined />}>
                  新增学员
              </Button>
                <Button type="primary" onClick={() => {
                  setStudentFullVisible(true);
                }} icon={<PlusOutlined />}>
                  新增学员及课包
              </Button>
              </div>
            }>
              <Table dataSource={students} columns={columns} pagination={false} scroll={{ x: 'true' }} onChange={onChange} />
              <div style={{ display: "flex", justifyContent: "flex-end", paddingTop: "10px" }}>
                <Pagination
                  defaultCurrent={pageNum}
                  total={pageTotal}
                  pageSize={pageSize}
                  hideOnSinglePage={false}
                  className="pagination"
                  onChange={onPageChange}
                  showSizeChanger
                  showTotal={total => `共计 ${total} 条`}
                />
              </div>
            </Card>
            <Collapse>
            <Panel header={<div style={{color:'red'}}>存在课时数为负的学员列表</div>} >
                <Table dataSource={fixStudents} columns={columns} pagination={false} scroll={{ x: 'true' }} onChange={onChange} />
            </Panel>
            </Collapse>
            <Collapse>
            <Panel header={<div style={{color:'red'}}>存在课程被失效的学员列表</div>} >
                <Table dataSource={courseInvalidStudents} columns={columns} pagination={false} scroll={{ x: 'true' }} onChange={onChange} />
            </Panel>
            </Collapse>
          </div>
        </Col>
      </Row>
      <Drawer
        title={studentDetail ? "编辑学员" : "新增学员"}
        visible={studentVisible}
        width={720}
        onClose={onClose}
        bodyStyle={{ paddingBottom: 80 }}
        destroyOnClose
      >
        <Form onFinish={onFinish} ref={formRef} layout="vertical" hideRequiredMark>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="name"
                label="姓名"
                rules={[{ required: true, message: '请输入姓名' }]}
              >
                <Input placeholder="请输入姓名" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="num"
                label="学号"
              >
                <Input disabled={true} placeholder="自动生成" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="phone"
                label="联系电话"
                rules={[{ required: false, message: '请输入联系电话' }]}
              >
                <Input placeholder="请输入联系电话" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="sex"
                label="性别"
                rules={[{ required: true, message: '请选择性别' }]}
              >
                <Radio.Group >
                  <Radio value={1}>男</Radio>
                  <Radio value={0}>女</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="birthday"
                label="生日"
                rules={[{ required: false, message: '请选择生日' }]}
              >
                <DatePicker style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="storeId"
                label="门店"
                rules={[{ required: true, message: '请选择门店' }]}
              >
                <Select placeholder="请选择门店"  >
                  {storeOptions}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          {studentDetail ?
          <Row gutter={16}>
          <Col span={24}>
              <Form.Item
                name="refStoreIds"
                label="关联门店"
                rules={[{ required: true, message: '请选择关联门店' }]}
              >
                <Select placeholder="请选择关联门店"  mode="multiple" >
                  {storeOptions}
                </Select>
              </Form.Item>
            </Col>
            </Row>
            :<></>}
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item
                name="remark"
                label="备注"
              >
                <Input placeholder="请输入备注" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item>
                <Button type="primary" htmlType="submit" loading={loading}>保存</Button>
                <Button htmlType="button" onClick={onClose}>取消</Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Drawer>

      <Drawer
        title={"补录课包"}
        visible={buyVisible}
        width={720}
        onClose={onClose}
        bodyStyle={{ paddingBottom: 80 }}
        destroyOnClose
      >
        <Form onFinish={buyCard} ref={buyformRef} layout="vertical" hideRequiredMark>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="name"
                label="姓名"
                rules={[{ required: true, message: '请输入姓名' }]}
              >
                <Input disabled={true} placeholder="请输入姓名" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="cardDefinitionId"
                label="课包"
                rules={[{ required: true, message: '请选择课包' }]}
              >
                <Select placeholder="请选择课包" onChange={onChangeCardDefinition} >
                  {cardDefinitionOptions}
                </Select>
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item
                name="count"
                label="数量"
                rules={[{ required: true, message: '请输入数量' }]}
              >
                <InputNumber min={1} max={100} onChange={onChangeBuyCardCount} />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            {/* <Col span={8}>
              <Form.Item
                name="calculateType"
                label="课包有效期计算规则"
                rules={[{ required: true, message: '请选择有效期计算规则' }]}
              >
               <Select onChange={onChangeCalculateType}>
                  <Option value="1">串行，叠加当前最长有效期</Option>
                  <Option value="2">并行，不叠加当前最长有效期</Option>
                </Select>
              </Form.Item>
            </Col> */}
            <Col span={12}>
              <Form.Item
                name="cardDefinitionEffectDay"
                label="课包有效天数（选择课包后自动生成）"
                rules={[{ required: true, message: '课包有效天数' }]}
              >
                <InputNumber disabled={true} style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="effectiveEndTime"
                label="课包有效截止时间（选择课包后自动生成）"
                rules={[{ required: true, message: '请输入课包有效截止时间' }]}
              >
                <DatePicker style={{ width: "100%" }}/>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="costPrice"
                label="实际花费价格"
                rules={[{ required: true, message: '请输入实际花费价格' }]}
              >
                <InputNumber style={{ width: '320px' }} placeholder="请输入实际花费价格" step="0.01" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="payWay"
                label="支付方式"
                rules={[{ required: true, message: '请选择支付方式' }]}
              >
                <Select placeholder="请选择支付方式" >
                  {payWayOptions}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="sendGifts"
                label="是否赠送礼品"
                rules={[{ required: true, message: '是否赠送礼品' }]}
              >
                <Select >
                  <Option value="true">是</Option>
                  <Option value="false">否</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="signContract"
                label="合同是否签署"
                rules={[{ required: true, message: '合同是否签署' }]}
              >
                <Select >
                  <Option value="true">是</Option>
                  <Option value="false">否</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item
                name="remark"
                label="备注"
                rules={[{ required: true, message: '请输入备注' }]}
              >
                <Input placeholder="请输入备注" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item>
                <Button type="primary" htmlType="submit" loading={loading}>保存</Button>
                <Button htmlType="button" onClick={onClose}>取消</Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Drawer>
      <Drawer
        title={"新增学员及课包"}
        visible={studentFullVisible}
        width={1080}
        onClose={onClose}
        bodyStyle={{ paddingBottom: 80 }}
        destroyOnClose
      >
        <Form onFinish={onFinishFull} ref={fullformRef} layout="vertical" hideRequiredMark>
          <Row gutter={16}>
            <Col span={6}>
              <Form.Item
                name="name"
                label="姓名"
                rules={[{ required: true, message: '请输入姓名' }]}
              >
                <Input placeholder="请输入姓名" />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name="num"
                label="学号"
              >
                <Input disabled={true} placeholder="自动生成" />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name="phone"
                label="联系电话"
                rules={[{ required: false, message: '请输入联系电话' }]}
              >
                <Input placeholder="请输入联系电话" />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name="sex"
                label="性别"
                rules={[{ required: true, message: '请选择性别' }]}
              >
                <Radio.Group >
                  <Radio value={1}>男</Radio>
                  <Radio value={0}>女</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={6}>
              <Form.Item
                name="birthday"
                label="生日"
                rules={[{ required: false, message: '请选择生日' }]}
              >
                <DatePicker style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name="storeId"
                label="门店"
                rules={[{ required: true, message: '请选择门店' }]}
              >
                <Select placeholder="请选择门店"  >
                  {storeOptions}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="remark"
                label="备注"
              >
                <Input placeholder="请输入备注" />
              </Form.Item>
            </Col>
          </Row>
          <Divider/>
          <Row gutter={16}>
                      <Col span={6}>
                      <Form.Item
                name="cardDefinitionId"
                label="课包"
                rules={[{ required: true, message: '请选择课包' }]}
              >
                          <Select placeholder="请选择课包" onChange={onChangeCardDefinition2} >
                            {cardDefinitionOptions}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={6}>
                        <Form.Item
                          name="cardCount"
                          label="数量"
                          rules={[{ required: true, message: '请输入数量' }]}
                        >
                          <InputNumber min={1} max={100} onChange={onChangeBuyCardCount2}/>
                        </Form.Item>
                      </Col>
            
                      <Col span={6}>
                        <Form.Item
                          name="cardCostPrice"
                          label="实际花费价格"
                          rules={[{ required: true, message: '请输入实际花费价格' }]}
                        >
                          <InputNumber style={{ width: '250px' }} placeholder="请输入实际花费价格" step="0.01" />
                        </Form.Item>
                      </Col>
                      <Col span={6}>
                        <Form.Item
                          name="cardPayWay"
                          label="支付方式"
                          rules={[{ required: true, message: '请选择支付方式' }]}
                        >
                          <Select placeholder="请选择支付方式" >
                            {payWayOptions}
                          </Select>
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row gutter={16}>
                    {/* <Col span={8}>
              <Form.Item
                name="calculateType"
                label="课包有效期计算规则"
                rules={[{ required: true, message: '请选择有效期计算规则' }]}
              >
               <Select onChange={onChangeCalculateType2}>
                  <Option value="1">串行，叠加当前最长有效期</Option>
                  <Option value="2">并行，不叠加当前最长有效期</Option>
                </Select>
              </Form.Item>
            </Col> */}
            <Col span={12}>
              <Form.Item
                name="cardDefinitionEffectDay"
                label="课包有效天数（选择课包后自动生成）"
                rules={[{ required: true, message: '课包有效天数' }]}
              >
                <InputNumber style={{ width: "100%" }} disabled={true} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="cardEffectiveEndTime"
                label="课包有效截止时间（选择课包后自动生成）"
                rules={[{ required: true, message: '请输入课包有效截止时间' }]}
              >
                <DatePicker style={{ width: "100%" }}/>
              </Form.Item>
            </Col>
            </Row>

                    <Row gutter={16}>
                      <Col span={6}>
                        <Form.Item
                          name="cardSendGifts"
                          label="是否赠送礼品"
                          rules={[{ required: true, message: '是否赠送礼品' }]}
                        >
                          <Select >
                            <Option value="true">是</Option>
                            <Option value="false">否</Option>
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={6}>
                        <Form.Item
                          name="cardSignContract"
                          label="合同是否签署"
                          rules={[{ required: true, message: '合同是否签署' }]}
                        >
                          <Select >
                            <Option value="true">是</Option>
                            <Option value="false">否</Option>
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item
                          name="cardRemark"
                          label="备注"
                          rules={[{ required: true, message: '请输入备注' }]}
                        >
                          <Input placeholder="请输入备注" />
                        </Form.Item>
                      </Col>
                    </Row>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item>
                <Button type="primary" htmlType="submit" loading={loading}>保存</Button>
                <Button htmlType="button" onClick={onClose}>取消</Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Drawer>
    </div>
  );
};

export default StudentView;
